<template>
  <div>
    <template  v-if="webVIewValidation() && !loading">
      <component v-bind:is="layout"></component>
    </template>
    <Loader v-if="loading" />
    <!-- <div class="sa-splash" v-else-if="!webVIewValidation()&&web"><img src="https://img.litedev.com/images/static/logo.svg" class="sa-img-cover-custom"></div> -->
  </div>
</template>
<script>
import DefaultlayoutVue from './layouts/Defaultlayout.vue';
import LoginlayoutVue from './layouts/Loginlayout';
// import firebase from './firebase'
import 'firebase/messaging'
// import serviveWorker from 'file-loader?name=firebase-messaging-sw.js!./firebase-messaging-sw.js';
import uniqid from "uniqid";
import io from "socket.io-client";
import { socket_url } from '../config/endpoints';
import { showNotification } from './util/notifications';
import { APPOINTMENT_NOTIFICATION, CHAT_NOTIFICATION, LOGIN, LOGOUT } from './util/constants';
import { bus } from './main';
import _ from 'lodash'
import Loader from './components/common/loader.vue';

export default {
  name: 'App',
  data() {
    return {
      socket: null,
      web:true,
      loading: true,
      test:false
    }
  },
  computed: {
    layout () {
      return this.$store.getters.getLayout
    }
  },
  components: {
    'login-layout': LoginlayoutVue,
    'default-layout': DefaultlayoutVue,
    Loader
  },
  mounted() {
    let token = this.$localStorage.get('token');
    
    if(token) {
      console.log('user logged in : ')
      this.socketInit()
    }
    bus.$on(LOGIN, this.socketInit)
    bus.$on(LOGOUT, this.disconnectSocket)
  },
  methods: {
    socketInit() {
      // connecting to socket hub
      let userInfo = JSON.parse(this.$localStorage.get("userdata")) || null;
      let did = uniqid();
      this.socket = io(socket_url, {
        query: `uid=${userInfo.uid}&did=${did}`,
        transports:["websocket"]
      });
      if (this.socket) {
        this.socket.on("connect", this.socketConnect);
        this.socket.on("disconnect", this.socketDisconnected);
      }
    },
    webVIewValidation(){
      if(typeof window != 'undefined' && !window.ReactNativeWebView&&this.layout){
        this.loading = false
        return true
      }else if(typeof window != 'undefined' && window.ReactNativeWebView){
        this.web= false
        this.loading = false
        this.test = false
        return true;
      }else{
        return false
      }
    },
    socketConnect() {
      console.log("Socket Connected...", this.socket);
      let socket = _.cloneDeep(this.socket)
      this.$store.dispatch('SET_SOCKET', socket)
      this.socket.on("INCOMING_MESSAGE", this.incomingMessage);
      this.socket.on("NEW_APPOINTMENT", this.newAppointment);
      this.socket.on("INAPP_NOTIFICATION", this.inappNotification);
      //TODO: New Appointment Event here
    },
    socketDisconnected() {
      console.log("Socket Disconnected...");
    },
    inappNotification: function(obj){
      if (obj) {
        let notifications = JSON.parse(JSON.stringify(this.$store.getters.getNotifications))
        let notificationCount = JSON.parse(JSON.stringify(this.$store.getters.getNotificationCount))
        notifications.unshift(obj)
        this.$store.dispatch('SET_NOTIFICATIONS', notifications)
        this.$store.dispatch('SET_NOTIFICATION_COUNT', notificationCount+1)
      }
    },
    incomingMessage(payload) {
      console.log('incoming msg payload : ', payload);
      // check if user not in same chatroom
      if (this.$router.history.current.path != '/appointments/chat-with-a-doctor/' + payload.chatroom_id) {
        showNotification({
          type: CHAT_NOTIFICATION,
          ...payload
        })
      }
    },
    newAppointment(payload) {
      console.log('new appointment : ', payload);
      showNotification({
        type: APPOINTMENT_NOTIFICATION,
        ...payload
      });
    },
    disconnectSocket() {
      console.log('disconnecting socket');
      if(this.socket) {
        this.socket.off("INCOMING_MESSAGE")
        this.socket.off("NEW_APPOINTMENT")
        this.socket.disconnect();
        this.socket = null;
      }
      
    }
  }
}
</script>

